import React from "react";
import PropTypes from "prop-types";
import { getPrefillData } from "../services/api/prefillFromDataStorage";
import { mapStorefrontToModel } from '../common/PrefillMapping/PrefillMapping';

class StorefrontQuery extends React.Component {
  handleStart() {
    if (this.props.onQuery) {
      this.props.onQuery();
    }
  }

  handleError(error) {
    if (this.props.onError) {
      this.props.onError(error);
    }
  }

  componentDidMount() {
    const { transactionId, token, onSuccess } = this.props;

    this.handleStart();

    this.request = getPrefillData({
        transactionId,
        token,
      })
      .then((response) => {
        if (response.data.vehicleData?.model?.brand) {
          // Analytics.initializeAdobe(response.data.vehicleData?.model?.brand);
        }
        return mapStorefrontToModel(response.data);
      })
      .then(
        (model) => onSuccess(model),
        (error) => this.handleError(error)
      );
  }

  render() {
    return this.props.children || null;
  }
}

StorefrontQuery.propTypes = {
  transactionId: PropTypes.string.isRequired,
  token: PropTypes.string,
  productModifier: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onQuery: PropTypes.func,
  onError: PropTypes.func,
};

export { StorefrontQuery };
